<template>
    <div class="search navigatable" :class="{inverted: inverted}" @click="focus">
        <div class="input">
            <input type="text" v-model="query">

            <span class="fa fa-spin fa-spinner" v-if="searching" @click="focus"></span>
            <span class="fa fa-search fa-fw" @click="focus" v-else></span>
        </div>

        <div class="results list-group" v-if="showResults && results.length" :class="{searching: searching}">
            <div class="loader-container" v-if="searching">
                <loader></loader>
            </div>

            <router-link :to="{name: 'reservations.view', params: {id: reservation.id}}" class="list-group-item result navigatable" v-for="reservation in results" :key="reservation.id">
                <div class="content">
                    <div class="pull-right muted">
                        <i>{{reservation.room.title}}</i>
                    </div>

                    <strong>{{reservation.name}}</strong><br />

                    <small>
                        {{reservation.arrival.date | moment("DD/MM")}}&nbsp;
                        <span class="fa fa-long-arrow-right fa-fw"></span>
                        {{reservation.departure.date | moment("DD/MM/YY")}}
                    </small>
                </div>
            </router-link>

            <div class="controls">
                <div v-if="results.length === 8" class="list-group-item navigatable text-center" @click="moreResults" data-action="more-results">
                    <span data-action="more-results">More results</span>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    $width: 240px;

    .search {
        position: relative;
        cursor: pointer;
        color: #fff;
        border-radius: 15px;
        height: 34px;

        .controls {
            color: #000;
        }

        .loader-container {
            position: absolute;

            width: 100%;
            height: 100%;

            background-color: rgba(255, 255, 255, 0.75);

            z-index: 10;
        }

        .input {
            overflow: hidden;
            display: inline-block;
            width: $width;
            border: 1px solid #fff;
            border-radius: 15px;

            input[type=text] {
                width: calc(#{$width} - 36px);
                color: #fff;
                background: transparent;
                padding: 6px 15px;
                border: 0;
                outline: 0;
            }
        }

        .results {
            position: absolute;
            right: 0;
            top: 50px;
            width: 400px;
            border-radius: 15px;
        }

        &.inverted {
            color: #adadad;

            .input {
                border-color: #adadad;

                input {
                    color: #adadad;
                }
            }
        }
    }
</style>

<script>
    const ReservationService = require('@/services/reservations/ReservationService')

    import Loader from '@/components/layout/Loader'

    export default {
        data() {
            return {
                query: null,
                timeout: null,
                delay: 500,
                searching: false,
                results: [],
                inverted: true,
                page: 1,
                showResults: false
            }
        },

        mounted() {
            document.onclick = (event) => {
                if (event.srcElement.getAttribute('data-action') === 'more-results') {
                    return
                }

                this.showResults = false
            }

            eventHub.$on('background.set', (src) => {
                this.inverted = (src === null)
            })

            if (this.$route && this.$route.params) {
                this.query = this.$route.params.query
            }
        },

        destroyed() {
            eventHub.$off('background.set', (src) => {
                this.inverted = (src === null)
            })
        },

        watch: {
            query() {
                this.page = 1
                this.searching = false

                if (this.timeout) {
                    clearTimeout(this.timeout)
                }

                if (!this.query || this.query.length < 3) {
                    this.showResults = false

                    return
                }

                this.timeout = setTimeout(this.search, this.delay)
            }
        },

        methods: {
            focus() {
                this.$el.querySelector('input').focus()
            },

            search() {
                this.searching = true

                const options = {
                    limit: 8,
                    page: this.page,

                    includes: ['room'],

                    sort: [
                        {
                            key: 'arrival',
                            direction: 'DESC'
                        }
                    ],

                    filter_groups: [
                        {
                            or: true,

                            filters: [
                                {
                                    key: 'name',
                                    value: this.query,
                                    operator: 'ct'
                                },
                                {
                                    key: 'room.title',
                                    value: this.query,
                                    operator: 'ct'
                                }
                            ]
                        }
                    ]
                }

                ReservationService.findAll(options, (response) => {
                    const data = response.data

                    this.results = data.rows
                    this.showResults = true
                    this.searching = false
                })
            },

            moreResults() {
                this.page++

                this.search()
            }
        },

        components: {
            Loader
        }
    }
</script>


// WEBPACK FOOTER //
// Search.vue?a039c72c